import React from 'react';
import { Landmark, RefreshCw } from 'lucide-react';
import i18n from '../../../../../i18n';

const BankAccountsEmpty = ({ message, actionText, onAction }) => {
  return (
    <div className="bank-accounts-empty">
      <span className="bank-accounts-empty__icon">
        <Landmark size={26} />
      </span>
      <p className="bank-accounts-empty__title"> {i18n.t('no_bank_accounts_yet')}</p>
      <p className="bank-accounts-empty__message">{message}</p>

      {onAction && (
        <button type="button" className="bank-accounts-empty__action" onClick={onAction}>
          <RefreshCw size={15} />
          {actionText}
        </button>
      )}
    </div>
  );
};

export default BankAccountsEmpty;
